import React, { useEffect, useCallback, useState, useRef } from 'react';
import generalsettingService from '../../../services/generalsettingService';
import GeneralSettingsForm from '../../../components/pageModule/GeneralSettings/GeneralSettingsForm';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';

const GeneralSettings = () => {
    const [initialData, setInitialData] = useState({
        prefix_purchase_number: '',
        title: '',
    });
    const isFetching = useRef(false);
    const [isLoading, setIsLoading] = useState(false);

    const handleCreate = async (formData) => {
        try {
            const response = await generalsettingService.saveSettings(formData);
            toast.success('General settings saved successfully', {
                position: 'top-right',
                autoClose: 500,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
            return response;
        } catch (error) {
            toast.error(error.message || 'Error saving General settings', {
                position: 'top-right',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
            throw error;
        }
    };

    const actions = {
        create: handleCreate,
    };

    const fetchData = useCallback(async () => {
        if (isFetching.current) {
            return;
        }
        isFetching.current = true;

        try {
            setIsLoading(true);
            const data = await generalsettingService.getSettings();
            setInitialData(data);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            isFetching.current = false;
            setIsLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <>
            <div className="row">
                <div className="col-lg-12">
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-12">
                                    <GeneralSettingsForm
                                        initialData={initialData}
                                        onSave={async (data) => {
                                            try {
                                                const response = await actions.create(data);
                                                await fetchData();
                                                return response;
                                            } catch (error) {
                                                console.error('Error saving settings:', error);
                                                throw error;
                                            }
                                        }}
                                        onClose={() => {
                                            console.log('cancel btn clicked');
                                        }}
                                        isLoading={isLoading}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default GeneralSettings;
